var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.9166 36.875V27.7917H91.375V18.7083H86.8333V14.1667H82.2916V9.62499H73.2083V5.08332H64.125V0.541656H36.875V5.08332H27.7916V9.62499H18.7083V14.1667H14.1666V18.7083H9.62496V27.7917H5.08329V36.875H0.541626V64.125H5.08329V73.2083H9.62496V82.2917H14.1666V86.8333H18.7083V91.375H27.7916V95.9167H36.875V100.458H64.125V95.9167H73.2083V91.375H82.2916V86.8333H86.8333V82.2917H91.375V73.2083H95.9166V64.125H100.458V36.875H95.9166ZM86.8333 64.125V73.2083H82.2916V82.2917H73.2083V86.8333H64.125V91.375H36.875V86.8333H27.7916V82.2917H18.7083V73.2083H14.1666V64.125H9.62496V36.875H14.1666V27.7917H18.7083V18.7083H27.7916V14.1667H36.875V9.62499H64.125V14.1667H73.2083V18.7083H82.2916V27.7917H86.8333V36.875H91.375V64.125H86.8333Z",
    fill: "url(#paint0_linear_2001_139)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2001_139",
    x1: 100,
    y1: 80.5,
    x2: 31.8637,
    y2: -2.57883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D8A23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#6778FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B468FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderAvatar);
export default __webpack_public_path__ + "static/media/borderAvatar.d92f70587397a6faafec2d404a849436.svg";
export { ForwardRef as ReactComponent };